import echarts from 'echarts'

echarts.registerTheme('co-op-theme', {
    color: ['#5A8BFF', '#5FA944', '#FF2E2E']
})

export default echarts
// 直接引用这个echarts